module.exports = __webpack_public_path__ + "img/undraw_Bibliophile_hwqc.3dc63a58.svg";